import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import { FormikProvider, useFormik } from 'formik';
import { useState, useEffect } from 'react';

import * as graphql from 'generated/graphql';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import HorizontalRule from 'packages/kakapo-ui-kit/components/common/HorizontalRule';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import useViewer from 'packages/kakapo-ui-application/hooks/useViewer';

import LearningFilterSidebar from '../components/LearningFilterSidebar';
import LearningCertificatesList from '../components/LearningCertificatesList';

export default function LearningCertificatesContainer() {
	const { t } = useTranslation();
	const viewer = useViewer();

	const formik = useFormik({
		initialValues: {
			types: [],
			subjects: [],
		},
		onSubmit: () => {},
	});

	const [certificates, setCertificates] = useState<graphql.LearningAwardedCertificate[]>([]);

	const { data, loading } = graphql.useUserWithCertificatesQuery({
		variables: {
			id: viewer!.id,
		},
	});

	useEffect(() => {
		if (!data) {
			setCertificates([]);

			return;
		}

		let filteredCertificates = data?.user.learningCertificates.edges.map(
			({ node }) => node as graphql.LearningAwardedCertificate,
		);

		if (formik.values.types.length > 0) {
			filteredCertificates = filteredCertificates.filter((certificate) =>
				formik.values.types.some((type) => certificate.event.learningType.id === type),
			);
		}

		if (formik.values.subjects.length > 0) {
			filteredCertificates = filteredCertificates.filter((certificate) =>
				formik.values.subjects.some((subject) =>
					certificate.event.learningSubjects.some((eventSubject) => eventSubject.id === subject),
				),
			);
		}

		setCertificates(filteredCertificates);
	}, [formik.values.types, formik.values.subjects, data?.user.learningCertificates]);

	return (
		<>
			<Box mb={3}>
				<SectionTitle>{t('learning.certificates.title')}</SectionTitle>
			</Box>

			<HorizontalRule />
			<Flex mt={4} flexWrap="wrap">
				<Box width={[1, 1, 1 / 3, 1 / 4]} pr={[0, 0, 3, 4]}>
					<FormikProvider value={formik}>
						<LearningFilterSidebar />
					</FormikProvider>
				</Box>

				<Box width={[1, 1, 2 / 3, 3 / 4]}>
					{!loading && data ? (
						<LearningCertificatesList certificates={certificates} />
					) : (
						<Spinner isLoading size="18px" />
					)}
				</Box>
			</Flex>
		</>
	);
}
